import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import {createEpicMiddleware} from 'redux-observable'
// position of this import is important
import {history} from 'utils'
import rootReducer, {RootState, AppActions} from './rootReducer'
import rootEpic from './rootEpic'

// NOTE: fix this so we don't have to do this
// @ts-ignore - we need this because of race condition to create the history object at this moment in execution
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const unusedVar = history

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
}

const pReducer = persistReducer<RootState>(rootPersistConfig, rootReducer)
const epicMiddleware = createEpicMiddleware<AppActions, AppActions, RootState>()
const middleware = [epicMiddleware]

if (process.env.NODE_ENV === 'development') {
  // middleware.push(logger)
}

const store = configureStore({
  reducer: pReducer,
  middleware,
})

/**
 * This env check is temp. unto we completely decouple 'app/store' from application layer
 * helps in avoiding RTL error: "epic is not a function"
 */
if (process.env.NODE_ENV !== 'test') epicMiddleware.run(rootEpic)

const persistor = persistStore(store)
export {persistor, store}

export type AppDispatch = typeof store.dispatch
export const dispatch: AppDispatch = store.dispatch

export type AppStore = typeof store

export type AppThunk<ReturnType = undefined> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
